import { render, staticRenderFns } from "./FormChildTemplateSelector.vue?vue&type=template&id=2bf47724&scoped=true"
import script from "./FormChildTemplateSelector.vue?vue&type=script&lang=js"
export * from "./FormChildTemplateSelector.vue?vue&type=script&lang=js"
import style0 from "./FormChildTemplateSelector.vue?vue&type=style&index=0&id=2bf47724&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf47724",
  null
  
)

export default component.exports